
import React, { useRef } from 'react'
import { useEffect, useState, useContext, useMemo } from 'react';
import { TextInput, Textarea, SimpleGrid, Group, Title, Button, Select, FileInput, ActionIcon, Text, Loader } from '@mantine/core';
//import { useForm } from '@mantine/form';
import { Card, Modal, Container, Row } from 'react-bootstrap';
import { IconCheck, IconTrendingUp2, IconUpload, IconInfoCircle, IconX, IconPlaystationX, IconFileUpload } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import axios from 'axios';
import { getSysId, getIncidentSysId, uploadFile, pushSql, raiseTicket,getRequestSysId } from '../services/dataService'
import { urls } from '../utils/apiConfigs';
import ReactTooltip, { Tooltip } from 'react-tooltip'
import { FaInfoCircle, FaFileUpload } from 'react-icons/fa';
import { BarLoader } from 'react-spinners';
import {roles,updateRoles} from '../Constants'
import { useNavigate } from "react-router-dom";
var SYS_ID;
var REQ_NUM;
var INC_NUM;
const Contactus = () => {
  //const fileInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const { instance, accounts } = useMsal();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [issueType, setIssueType] = useState('');
  const [toolname, setToolName] = useState('');
  const [files, setFiles] = useState([]);
  const [validate, setValidate] = useState('this field is required');
  const handleValidate = () => setValidate(false);
  const [showProgress, setShowProgress] = useState(false);
  const [issueDescription, setIssueDescription] = useState('')
  const [shortDescription, setShortDescription] = useState('')
  const [requestType, setRequestType] = useState("");
  const [showCompleted, setShowCompleted] = React.useState(false);
  const navigate = useNavigate();
// State for Change Request fields
const [costCenter, setCostCenter] = useState("");
const [companyCode, setCompanyCode] = useState("");
const [glAccount, setGlAccount] = useState("");
const [number, setNumber] = React.useState(null);
// State for Access to Application fields
const [typeOfAccess, setTypeOfAccess] = useState("");
const [userEmail, setUserEmail] = useState("");

  const options = [
    {
      label: 'Issue',
      value: 'Issue',
    },
    {
      label: 'Change Request',
      value: 'Change Request',
    },
    {
      label: 'Access to application',
      value: 'Access to application'
    },
  ];


  const handleFileUpload = (e) => {
    const files = e.target.files;
    // Handle the file upload logic here
    console.log("File uploaded:", files[0].name);
    const selectedFile = e.target.files[0];
    // Handle the file upload logic here
    console.log("File uploaded:", selectedFile.name);
    setFiles([selectedFile]);

    // You can perform additional actions or send the file to a server
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const option = [
    {
      label: 'Customer Complaint Portal',
      value: 'CQ',
    },
    {
      label: 'One Order Change Portal',
      value: 'One Order Change Portal',
    },
    {
      label: 'Ret Pack Portal',
      value: 'Ret Pack Portal',
    },
    {
      label: 'MDM ticketing Portal',
      value: 'MDM ticketing Portal',
    },
    {
      label: 'BeerBot',
      value: 'BeerBot',
    },
  ];
  const [errors, setErrors] = useState(
    {
      requestTypeE: false,
      shortDescriptionE: false,
      issueDescriptionE: false,
      issueToolE: false
    }
  );
  // const form = useForm({
  //   initialValues: {
  //     shortDescription: '',
  //     issueDescription: '',
  //   },
  //   validate: {
  //     shortDescription: (value) => value.trim().length === 0,
  //     issueDescription: (value) => value.trim().length === 0,
  //   },
  // });
  async function getSysID() {
    var name = (roles.username);
    getSysId(`${name}`).then((res) => {
      console.log(res,"kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")
      SYS_ID = res.result[0].sys_id;
      console.log(SYS_ID);
    })
      .catch((e) => {
        console.log(e)
      });
  }

  useEffect(() => {
    getSysID();
  }, []);

  useEffect(() => {
    if (requestType === "Change Request") {
      axios({
        method: "get",
        url: urls.downloadCRFileProduct,
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.getElementById("CRFileLinkProduct");
          if (link) {
            link.href = url;
            link.setAttribute("download", "crtemplatefile.docx");
          }
        })
        .catch((error) => {
          console.error("Error fetching CR file:", error);
        });
    }
  }, [requestType]); // Runs only when requestType changes
  
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setFiles((prevSelectedFiles) => [
      ...prevSelectedFiles,
      ...files.map((file) => file.name),
    ]);

  };
  const removeAttachment = () => {
    setFiles('');
  }
  const onSubmit = (e) => {
    setShowProgress(true);
    e.preventDefault();
    console.log("llllllllllllllllllllllllllllllllllllllllllllll")
    //  const value = form.values;

    if (requestType === '' || shortDescription === '' || issueDescription === '' || toolname === '') {
      setErrors(
        {
          requestTypeE: requestType === '' ? true : false,
          shortDescriptionE: shortDescription === '' ? true : false,
          issueDescriptionE: issueDescription === '' ? true : false,
          issueToolE: toolname === '' ? true : false
        }
      )
      setShowProgress(false);
      return;
    }
    console.log(`Hi, I'm in ${requestType} request`);
setShowProgress(true);

let data = {
  sys_id: SYS_ID,
  zone: "ISC",
  projectName: toolname,
  caller_id: roles.username,
  tower: "NULL",
  poc: "NULL",
  short_description: shortDescription,//CR, ATA
  issueDescription: issueDescription,
  typeOfSolution: "product",
  urgency: '3',
  priority: '3',
  username: roles.username,
};

// Common assignment group and business service
const assignmentGroup = "47259ddc97fda91071adb9b0f053af61";
const businessService = "62a65f2fdbf92090c014fe03f3961915";
switch (requestType) {
  case "Issue":
    Object.assign(data, {
      issueType: "",
      requestType: "issue",
      shortDescription: shortDescription,//issue
      assignmentGroup,
      businessService,
      category: "PWA",
      pointOfContact: roles.username,
    });
    RaiseTicket(data);
    break;

  case "Access to Application":
    Object.assign(data, {
      issueType: "u_changeRequest_product",
      requestType: "ATA",
      assignment_group: assignmentGroup,
      business_service: businessService,
      typeOfAccess: typeOfAccess,
      userEmailId: userEmail,
      attachment: ""
    });
    RaiseRequestTicket(data);
    break;

  default:
    Object.assign(data, {
      issueType: "u_changeRequest_product",
      requestType: "CR",
      assignment_group: assignmentGroup,
      business_service: businessService,
      costCenter: costCenter,
      glAccount: glAccount,
      companyCode: companyCode,
    });
    RaiseRequestTicket(data);
}
async function pushSql(data) {//for issue
  axios.post(urls.pushSQL, data, {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('snowtoken')}`,
    }
  }).then((response) => {
     console.log(response);
     console.log("date uploaded successfully");
    setShowProgress(false);
    setShowCompleted(true);
  });
}
async function uploadFILE(data) {//issue

  //     files.forEach((file) => {

  //       const formData = new FormData();

  //       formData.append("attachment", file);
  //       formData.append("sys_id", data["IncidentSysId"]);    

  //       uploadFile(formData)
  //       .catch((e) => {
  //         console.log(e);
  //       })

  //     });
  console.log('Inside Upload File');
  const formData = new FormData();
  formData.append("attachment", files[0]);
  formData.append("sys_id", data["IncidentSysId"]);
  console.log('Inside uploadFile', files[0], data["IncidentSysId"]);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": `Bearer ${(localStorage.getItem('snowtoken'))}`
    },
  };
  axios.post(urls.UploadFile, formData, config).then((response) => {
    console.log('File Uploaded');
  })
}
async function getIncidentSysID(incidentNumber) {
  getIncidentSysId(incidentNumber).then((res) => {
    data["IncidentSysId"] = res.result[0].sys_id;
  uploadFILE(data);
  pushSql(data);
  });
}
async function uploadFile(data) { // for Requests
  console.log('Inside Upload File');
  const formData = new FormData();
  formData.append("attachment", files[0]);
  formData.append("sys_id", data["requestSysId"]);
  console.log('Inside uploadFile', files[0], data["requestSysId"]);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": `Bearer ${(localStorage.getItem('snowtoken'))}`
    },
  };
  axios.post(urls.UploadFile, formData, config).then((response) => {
    console.log('File Uploaded');
  })
}


async function getRequestSysID(requestNumber) {
  getRequestSysId(requestNumber).then((res) => {
    data["requestSysId"] = res.result[0].sys_id;
    uploadFile(data);
    pushSQL(data);
  })
}
async function pushSQL(data) { //for requests
  axios.post(urls.pushSQLProduct, data, {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('snowtoken')}`,
    }
  }).then((response) => {
    // console.log(response);
    // console.log("date uploaded successfully");
    console.log("Response Data:", response.data);  // Log response data
  console.log("Response Status:", response.status);
    setShowProgress(false);
    setShowCompleted(true);
  });
}

async function RaiseRequestTicket(data) {
      raiseTicket(data).then((res) => {
        data["requestNumber"] = res.result.number;
        setNumber(data["requestNumber"]);
        REQ_NUM = data["requestNumber"];
        console.log(REQ_NUM);
        getRequestSysID(REQ_NUM);
        setTimeout(() => {
          handleShow();
        }, 3000);
      })
        .catch((e) => {
          console.log(e);
          alert('Upload Error');
          window.location.reload();
        });
    }
async function RaiseTicket(data) {
  raiseTicket(data).then((res) => {
    data["IncidentNumber"] = res.result.number;
    setNumber(data["IncidentNumber"]);
    INC_NUM = data["IncidentNumber"];
    console.log(INC_NUM);
    getIncidentSysID(INC_NUM);
    setTimeout(() => {
      handleShow();
    }, 3000);
  })
    .catch((e) => {
      console.log(e);
      alert('Upload Error');
      window.location.reload();
    });
}



  }
  return (
    <Container>
  <form onSubmit={onSubmit}>
    <div xs={12} sm={11} md={11} lg={9} style={{ margin: "auto", padding: "0 5vw 0 5vw" }}>
      <Card style={{ padding: "20px 30px 30px 40px", width: "100%" }}>
        
        {/* Title */}
        <h2 style={{ fontWeight: "bold", color: "#f1c40f", textAlign: "left", marginBottom: "20px" }}>Contact Us</h2>

        <hr style={{ color: "black", margin: "1rem 0" }} />

        <p style={{ fontSize: "medium", fontWeight: "600", color: "black", textAlign: "left", marginBottom: "20px" }}>
          Please fill the following details to create a support ticket. The team will get back to you shortly.
        </p>

        <Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
          <label style={{ fontSize: "medium", fontWeight: "500", color: "black", textAlign: "left",marginBottom: "5px"  /* Space between label and dropdown */}}>
          Type of Issue
          </label>
          <select name="requestType" value={requestType} onChange={(e) => setRequestType(e.target.value)}
          className="form-select"
          style={{ border: "1px solid rgb(204, 204, 204)", borderRadius: "12px", fontsize:"8px", padding: "8px", height: "40px",width: "100%",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",transition: "border-color 0.2s ease-in-out",color: "black",marginLeft: "15px"  /* Slight right indentation */

          }}>
            <option disabled value="">Select an option</option>
            <option value="Issue">Issue</option>
            <option value="Change Request">Change Request</option>
            <option value="Access to Application">Access to Application</option>
            </select>
        </Row>
{/* Fields for Change Request */}
{requestType === "Change Request" && (
  <>
    <Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
      <label style={{ fontSize: "medium",fontWeight: "500", color: "black", textAlign: "left",marginBottom: "5px"  /* Space between label and input */
      }}>
        Cost Center *
      </label>
      <input type="text" placeholder="Enter Cost Center" className="form-control" value={costCenter}
        onChange={(e) => setCostCenter(e.target.value)}
        style={{ border: "1px solid rgb(204, 204, 204)", borderRadius: "12px", padding: "10px", width: "100%", maxWidth: "31.5vw", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          transition: "border-color 0.2s ease-in-out",
          color: "black",
          marginLeft: "15px"  
        }}
      />
    </Row>

    <Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
      <label style={{ fontSize: "medium", fontWeight: "500", color: "black", textAlign: "left",marginBottom: "5px"}}>
        Company Code *
      </label>
      <input type="text"placeholder="Enter Company Code" className="form-control"
        value={companyCode}
        onChange={(e) => setCompanyCode(e.target.value)}
        style={{ border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",padding: "10px",width: "100%",maxWidth: "31.5vw",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          transition: "border-color 0.2s ease-in-out",
          color: "black",
          marginLeft: "15px"
        }}
      />
    </Row>

    <Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
      <label style={{ fontSize: "medium", fontWeight: "500", color: "black", textAlign: "left", marginBottom: "5px"
      }}>
        GL Account *
      </label>
      <input
        type="text"
        placeholder="Enter GL Account"
        className="form-control"
        value={glAccount}
        onChange={(e) => setGlAccount(e.target.value)}
        style={{border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",padding: "10px",width: "100%",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",transition: "border-color 0.2s ease-in-out",
          color: "black",
          marginLeft: "15px"
        }}
      />
    </Row>
  </>
)}


{/* Fields for Access to Application */}
{requestType === "Access to Application" && (
  <>
    <Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
      <label style={{fontSize: "medium", fontWeight: "500", color: "black", textAlign: "left",
        marginBottom: "5px" }}>
    Type of Access
  </label>
  <input
    type="text"
    placeholder="Enter Type of Access"
    className="form-control"
    value={typeOfAccess}  
    onChange={(e) => setTypeOfAccess(e.target.value)} 
    style={{border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",padding: "10px",width: "100%",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      transition: "border-color 0.2s ease-in-out",
      color: "black",
      marginLeft: "15px" 
    }}
  />
</Row>


<Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
  <label style={{ fontSize: "medium", fontWeight: "500",color: "black", textAlign: "left",marginBottom: "5px"  /* Space between label and input */
  }}>
    User Email ID*
  </label>
  <input
    type="email"
    placeholder="Enter User Email ID"
    className="form-control"
    value={userEmail}
    onChange={(e) => setUserEmail(e.target.value)}  
    style={{border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",padding: "10px",width: "100%",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",transition: "border-color 0.2s ease-in-out",
      color: "black",
      marginLeft: "15px"  
    }}
  />
</Row> 
</>
)}

{/* Tool Name Dropdown */}
<Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
  <label style={{ fontSize: "medium", fontWeight: "500", color: "black", textAlign: "left",marginBottom: "5px"
  }}>
    Tool Name*
  </label>
  <select
    name="toolname"
    value={toolname}
    onChange={(e) => setToolName(e.target.value)}
    className="form-select"
    style={{border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",width: "100%",fontsize:"10px",padding: "8px",height: "40px",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",transition: "border-color 0.2s ease-in-out",color: "black",marginLeft: "15px"
    }}
  >
    <option disabled value="">Select an option</option>
    {option.map((item) => (
      <option key={item.value} value={item.value}>{item.label}</option>
    ))}
  </select>
</Row>

{/* Subject Field */}
<Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
  <label style={{fontSize: "medium", fontWeight: "500",color: "black", textAlign: "left",marginBottom: "5px"
  }}>
    Subject *
  </label>
  <input
    className="form-control"
    type="text"
    placeholder="Enter Subject"
    name="shortDescription"
    value={shortDescription}
    onChange={(e) => setShortDescription(e.target.value)}
    style={{border: "1px solid rgb(204, 204, 204)",borderRadius: "12px",padding: "10px",width: "100%",maxWidth: "31.5vw",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",transition: "border-color 0.2s ease-in-out",
      color: "black",
      marginLeft: "15px"
    }}
  />
  {errors.shortDescriptionE && (
    <div style={{ color: "red", marginTop: "5px" }}>{validate}</div>
  )}
</Row>
{/* Short Description Field */}
<Row style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
  <div>
    <p style={{ 
      fontSize: 'medium', 
      fontWeight: '500', 
      color: 'black', 
      textAlign: 'left', 
      marginBottom: "3px" 
    }}>
      Issue Description *
    </p>
  </div>
</Row>

<Row style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
  <div style={{ minWidth: "250px", width: "31.5vw", borderRadius: "14px", marginLeft: "5px", marginBottom: "15px" }}>
    <textarea
      className='form-control'
      placeholder="Enter Short Description"
      rows={3} 
      name="issueDescription"
      value={issueDescription}
      onChange={(e) => setIssueDescription(e.target.value)}
      style={{
        minWidth: '250px',
        width: '30vw',
        padding: '10px',
        borderRadius: '10px',
        border: '1px solid #ccc',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'border-color 0.2s ease-in-out',
      }}
    />
    {errors.issueDescriptionE && (
      <div style={{ color: 'red', marginTop: '5px' }}>{validate}</div>
    )}
  </div>
</Row>

            {/* <Row>
                        <div style={{display:'flex'}}>
                            <div style={{ paddingBottom: '7px' }}>
                                <Text size="md" weight={500} color="black" align="left">{`Attachment *`}</Text>
                           </div>
                            
                        <Tooltip
                              multiline
                              width={270}
                              withArrow
                              transition="fade"
                              transitionDuration={200}
                              label={<div><div>Attach relevant email chains or error screenshots with your request to support the ticket.</div> <div>For multiple attachments please provide the zip folder.</div></div>}
                              >
                               <ActionIcon>
                                <IconInfoCircle size={18} strokeWidth={2} color={'#fab005'} />
                              </ActionIcon> 
                            </Tooltip>
                            </div>
                            <div style = {{paddingLeft: "10px"}}>
                                <Row>
                                    <Text size="11px" weight={400} color="black" align="left" style={{paddingTop:"5px"}}>{`(Strictly allowed File types : .zip, .png , .jpeg, .jpg, .docx, .xlsx, .csv)`}</Text>
                                    </Row>
                            </div>
                    </Row>
                            <Row>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="mp-attachment"
                                                    multiple
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                />
                                                
                                                <div className='upload-sec' style = {{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        padding: "9px 9px 3px 9px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "5px",
                                                        marginTop: "5px",
                                                        cursor: "pointer",
                                                        maxWidth: '30vw'
                                                }}>
                                                    <div style= {{paddingRight: "15px"}}>
                                                        <label style={{ marginBottom: "0.2rem"}}>Choose Files</label>
                                                        <div style={{ maxWidth: '100px', fontWeight: 600, fontSize: 10, paddingBottom: "3px"}}> (Max-Size: 5MB) </div>
                                                    </div>
                                                    <div >
                                                        <label htmlFor="mp-attachment" id="uploadEvidencebtn">
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                component="span"
                                                            >
                                                                 <IconFileUpload/> 
                                                            </Button>

                                                        </label>
                                                    </div>
                                                </div>
                                                
                                                
                                                <div className="attachment-links" style = {{paddingLeft: "10px", paddingTop : "30px" ,maxWidth: '30vw'}}>
                                                      {files && files.length > 0 ? (
                                                        files.map((fileName) => (
                                                          <div className="attachment-links" key={fileName}>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                              <div>{fileName}</div>
                                                              <IconPlaystationX
                                                                className="close-icon"
                                                                onClick={() => removeAttachment(fileName)}
                                                                style={{ cursor: "pointer", transform: "scale(0.8)", marginLeft: "0.5rem" }}
                                                              />
                                                            </div>
                                                          </div>
                                                        ))
                                                      ) : (
                                                        ""
                                                      )}

                                                  </div>
                                                
                                                </Row>
                                                <Row>
                                    <Text size="11px" weight={400} color="black" align="left" style={{paddingTop:"5px"}}>{`(Please attach relevant email chains or screenshots with your request to support the ticket and faster resolution)`}</Text>
                                    </Row> */}
            {/* CR Template Section */}
            {requestType === "Change Request" && (
            <>
            <Row style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
              <div style={{ flex: "0 0 200px", textAlign: "left" }}>
                <p style={{ fontSize: 'medium', fontWeight: '500', color: 'black', marginBottom: "10px" }}>
                  CR Template
                </p>
              </div>
              <div style={{ flex: "1", textAlign: "left" }}>
                <a 
                  href="#" 
                  id="CRFileLinkProduct" 
                  style={{ 
                    textDecoration: "none", 
                    color: "#f5a623", 
                    transition: "color 0.2s ease-in-out"
                  }}
                  onMouseOver={(e) => e.target.style.color = "#007bff"}
                  onMouseOut={(e) => e.target.style.color = "#f5a623"}
                >
                  Click Here to download Change Request Template
                </a>
              </div>
            </Row>
            </>
)}
            <Row>
              <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "left", flexWrap: "wrap" }}>
                <div style={{ paddingBottom: '7px' }}>
                  <p style={{ fontSize: 'medium', fontWeight: '500', color: 'black', textAlign: 'left' }}>
                    Attachment
                  </p>

                </div>
                <div>
                  <Tooltip
                    multiline
                    maxWidth={270}
                    withArrow
                    transition="fade"
                    transitionDuration={200}
                    label={<div><div>Provide relevant error screenshots regarding your query.</div> <div>For multiple attachments please provide the zip folder.</div></div>}
                  >
                    <div style={{ marginRight: '10px' }}>
                      <FaInfoCircle size={18} color={'#fab005'} />
                    </div>
                  </Tooltip>
                </div>
                <div style={{ paddingLeft: "10px" }}>
                  <Row>
                    <p data-tip="Tooltip content" data-place="bottom" style={{ fontSize: '11px', fontWeight: '400', color: 'black', textAlign: 'left', paddingTop: '2px' }}>
                      (Strictly allowed File types : .zip, .png , .jpeg, .jpg, .docx, .xlsx, .csv, .pdf)
                    </p>

                  </Row>
                </div>
              </div>
            </Row>
            <Row>
              <div class="mb-3">

                {/* <input class="form-control form-control" id="formFile" type="file"
                    className="form-control"
                   
                    multiple={false}
                    style={{
                      minWidth: '250px',
                      width: '30vw',
                      marginTop: '0px',
                      padding: '10px',
                      borderRadius: '10px',
                      border: '1px solid #ccc',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      transition: 'border-color 0.2s ease-in-out',
                    }}
                    
                    accept="image/png,image/jpeg,application/pdf,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip"
                    onChange={(e) => {
                      setFiles(e.target.files);
                    }
                  }
                 
                  ></input> */}
                <div style={{
                  textAlign: 'center', marginTop: '50px',
                }}>


                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '20px',
                      border: '2px dashed #ccc',
                      cursor: 'pointer',
                      minWidth: '250px',
                      width: '30vw',

                    }}
                    onClick={handleClick}
                  >
                    <div style={{ fontSize: '40px', marginBottom: '10px' }}>📤</div>
                    <div>Click to Upload</div>
                    <div>Max size 2MB</div>
                  </div>

                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}

                    onChange={handleFileUpload}

                  />
                </div>
              </div>



              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div className="attachment-links" style={{ paddingLeft: '10px', paddingTop: '10px', maxWidth: '30vw' }}>
                  {files[0]?.name ? <div>{files[0]?.name}</div> : <div>{files[0]?.fileName}</div>}
                </div>
                <div style={{ paddingLeft: '5px', paddingTop: '10px' }}>
                  {files[0]?.name ? <div onClick={removeAttachment} style={{ cursor: 'pointer' }}>Remove Attachment</div> : ""}
                </div>
              </div>


            </Row>
            {/* <Group position="right" mt="xl">
              <Link to="/">
                 <button
                  color="gray"
                  radius="xl"
                  leftIcon={<IconX size={16} color="white" />}
                >{`Cancel`}</button> 
              </Link>
              
              <button
                type="submit"
                color="yellow"
                radius="xl"

                leftIcon={<IconCheck size={16} color="white" />}
              >{`Submit`}</button> 
            </Group> */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
              <Link to="/">
                <button style={{ color: '#333', borderRadius: '14px', padding: '12px', marginRight: '10px', backgroundColor: '#e0e0e0', width: '200px', border: 'none', cursor: 'pointer', transition: 'background-color 0.3s' }}>
                  Cancel
                </button>
              </Link>

              <button
                type="submit"
                style={{ color: '#333', backgroundColor: '#fcbf49', borderRadius: '14px', padding: '12px', width: '200px', border: 'none', cursor: 'pointer', transition: 'background-color 0.3s' }}
              >
                Submit
              </button>
            </div>


          </Card >
        </div >
      </form >
      <Modal show={showProgress} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body text-align="center">
          Please wait we are communicating your query to SNOW team.
          <BarLoader
            color="gray"
            height={5}
            width={150}
            css={{ margin: 'auto', display: 'block', paddingTop: '15px' }}
          />
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Note</Modal.Title>
          <Link to="/">
            <IconX color="black" />
          </Link>

        </Modal.Header>
        <Modal.Body text-align="center">
        Your ticket has been raised with Number: {number}.
        </Modal.Body>
        <Modal.Footer>
          <Link to="/">
            <button
              color="gray"
              radius="xl"
              leftIcon={<IconX size={16} color="white" />}
            >{`Close`}</button>
          </Link>
        </Modal.Footer>
      </Modal>


    </Container>

  );
}

export default Contactus;